import React from 'react'
import styles from './style/configuration_favorite_call_to_action_style.module.scss'
import { connect } from 'react-redux'
import { getFavoriteConfigurations, isLoading } from '../../../../store/cut-to-size/reducers'
import LocalizedLink from '../../../global/LocalizedLink'
import Spinner from '../../../global/Spinner'
import configurationFavoriteImage from './assets/configuration-favorite-cta.png'
import Translation from '../../../global/Translation'

const mapStateToProps = (state) => {
    return {
        favoriteConfigurations: getFavoriteConfigurations(state),
        isLoading: isLoading(state)
    }
}

const ConfigurationFavoriteCallToAction = (props) => {
    const { favoriteConfigurations, isLoading } = props

    const total =
        favoriteConfigurations && favoriteConfigurations.totalElements
            ? favoriteConfigurations.totalElements
            : 0

    return (
        <div className={styles['configuration-favorite-cta']}>
            <div className={styles['configuration-favorite-cta__card']}>
                {/* Image */}
                <div className={styles['configuration-favorite-cta__image-wrapper']}>
                    <img
                        src={configurationFavoriteImage}
                        alt="Configuraciones guardadas"
                        className={styles['configuration-favorite-cta__image']}
                    />
                </div>

                {/* Content */}
                <div className={styles['configuration-favorite-cta__content']}>
                    <h3 className={styles['configuration-favorite-cta__title']}>
                        <Translation id={"your_saved_configurations"} defaultMessage={"Your saved configurations"}/> (
                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                            {isLoading ? (
                                <Spinner isLoading={isLoading} relative small />
                            ) : (
                                <span>{total}</span>
                            )}
                        </span>
                        )
                    </h3>

                    <p className={styles['configuration-favorite-cta__description']}>
                        <Translation id={"access_your_saved_configurations_to_continue_editing_them_or_complete_your_purchase"} defaultMessage={"Access your saved configurations to continue editing them or complete your purchase."} />
                    </p>

                    <LocalizedLink
                        routeId="ROUTE_CONFIG_CUT_TO_SIZE_FAVORITE"
                        className={styles['configuration-favorite-cta__link']}
                        gtmLabel="custom-products_link_go-to--saved-custom-drafts"
                    >
                        <Translation id={"access"} defaultMessage={"Access"} />
                        <i className="fas fa-chevron-right"></i>
                    </LocalizedLink>
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps, null)(ConfigurationFavoriteCallToAction)
